import React, { createContext, useContext, useReducer } from 'react';
import { getGoogleMapsConfig } from '../../../project/appConfiguration';
import { googleMapHandlers, googleMapInitialState, googleMapReducer } from '../reducers/GoogleMapReducer';
import { DisplayContext } from './DisplayContext';
import { FirestoreContext } from './FirestoreContext';
import { ParentContext } from './ParentContext';
import { UiItemContext } from './UiItemContext';
import { pageFunctions } from '../reducers/PageReducer';
import usePageFunctions from './useHelpers/usePageFunctions';

/** AppContext */
export const GoogleMapContext = createContext();

/** Global OtherDatas for the Event */
const GoogleMapProvider = (props) => {

  const gm = getGoogleMapsConfig()
  const { apiKey } = gm ?? {}

  let { mapLists, geoListType, locationsOf } = props

  const { getGviDeps } = usePageFunctions()

  // firestoreContext
  const firestoreContext = useContext(FirestoreContext)
  const { firestore_handlers } = firestoreContext ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { currentSettings_state, paps_state } = states

  // PageContext 
  const { pathViews } = paps_state ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { dataPermissions } = aps_global ?? {}
  const { autoUpdateMapPositions } = dataPermissions ?? {}

  const uiItemContext = useContext(UiItemContext)
  const { item_state } = uiItemContext ?? {}
  const { viewItem, viewListData } = item_state ?? {}

  // DisplayContext
  const displayContext = useContext(DisplayContext)
  const { display_state } = displayContext ?? {}
  const { displayProps } = display_state ?? {}

  // reducer
  const initState = googleMapInitialState({
    apiKey,
    autoUpdateMapPositions,
    displayProps,
    firestore_handlers,
    getGviDeps,
    geoListType,
    locationsOf,
    mapLists,
    pathViews,
    viewItem,
    viewListData,
  })

  const [googleMap_state, dispatch] = useReducer(googleMapReducer, initState);
  const googleMap_handlers = googleMapHandlers(dispatch)

  const providerContext = () => <GoogleMapContext.Provider
    value={{ googleMap_handlers: googleMap_handlers, googleMap_state: googleMap_state }}>
    {props.children}
  </GoogleMapContext.Provider>

  return providerContext()
}

export default GoogleMapProvider